import Viewers from '@/views/viewer/Viewers'

export default [
  {
    path: 'visores',
    name: 'viewer.list',
    component: Viewers
  }
]
